<nx-checkbox
  class="nx-margin-bottom-s"
  [ngClass]="alignContentToTheLeft ? 'auslaendischeAdresseCheckboxLeft' : 'auslaendischeAdresseCheckbox'"
  [checked]="isChecked"
  (checkedChange)="clickOnCheckbox($event)"
  >{{ text }}</nx-checkbox
>
